import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const ChatRoomsList = React.lazy(() => import("./ChatRoomsList"));
const ChatRoomDetail = React.lazy(() => import("./ChatRoomDetail"));

const seamlessChatModuleConfig: ModuleConfig = {
    id: "seamless-chat",
    name: "Seamless Chat",
    description: "Zero-friction anonymous chat rooms with shareable links",
    version: "1.0.0",
    enabled: true,
    category: "communications",
    order: 20,
    icon: "FiMessageCircle",
    color: "#007AFF",

    routes: [
        {
            path: "/seamless-chat",
            component: ChatRoomsList,
            permissionLevel: "view",
            useLayout: true,
        },
        {
            path: "/seamless-chat/:id",
            component: ChatRoomDetail,
            permissionLevel: "view",
            useLayout: true,
        },
    ],

    navigation: [
        {
            label: "Chat Rooms",
            path: "/seamless-chat",
            icon: "FiMessageCircle",
            permissionLevel: "view",
        },
    ],

    permissions: {
        view: [],
        create: [],
        edit: [],
        delete: [],
    },

    quickActions: [
        {
            label: "New Chat Room",
            path: "/seamless-chat",
            icon: "FiMessageCircle",
            description: "Create a new shareable chat room",
        },
    ],

    changelog: [
        {
            version: "1.0.0",
            releaseDate: "2026-03-10",
            title: "Initial Release - Seamless Chat",
            features: [
                "Zero-friction anonymous chat (no login required)",
                "Shareable room links via /c/:slug",
                "Real-time messaging via GraphQL subscriptions",
                "Typing indicators and presence",
                "Progressive authentication (anonymous to logged in)",
                "Admin room management and moderation",
            ],
            notes: "SMS a link to anyone — they start chatting instantly.",
        },
    ],
};

export default seamlessChatModuleConfig;
